import getStateKey from 'ee/vue_merge_request_widget/stores/get_state_key';

export default getStateKey;
